import styled from 'styled-components'

export const StyledComsumerContainer = styled.div`
  background-image: linear-gradient(to bottom, rgba(30, 31, 35, 1), rgba(30, 31, 35, 1));
  ${props => props?.lightBg && 'background: #fff;'};
  background-attachment: fixed;
  min-height: 100vh;
`

export const StyledMoodAskerContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme?.themeC5};
  padding: 35px;
  flex-direction: column;
  gap: 45px;
  @media (min-width: 768px) {
    gap: 60px;
  }
`

export const MoodAskerHeading = styled.div`
  color: #000;
  font-family: Outfit;
  font-size: 29px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  cursor: default;
  text-align: center;
  @media (min-width: 768px) {
    font-size: 35px;
    line-height: 39px;
  }
  @media (min-width: 1500px) {
    font-size: 41px;
    line-height: 45px;
  }
`

export const OptionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  @media (min-width: 768px) {
    gap: 40px;
  }
`

export const SkipButtonBottomRight = styled.div`
  cursor: pointer;
  color: #000;
  position: absolute;
  bottom: 30px;
  margin: 0 auto;
  font-size: 18px;
  font-family: Outfit;
  font-weight: 500;
  @media (min-width: 768px) {
    bottom: 50px;
    font-size: 18px;
    font-family: Outfit;
    font-weight: 500;
  }
  @media (min-width: 1500px) {
    bottom: 70px;
    font-size: 18px;
    font-family: Outfit;
    font-weight: 500;
  }
`

export const MoodIcon = styled.img`
  cursor: pointer;
  width: 40px;
  height: 40px;
  transition: all 0.05s ease-in-out;
  &:hover {
    transform: translateY(-5px);
  }
  @media (min-width: 768px) {
    width: 64px;
    height: 64px;
  }
`

// flow component

export const FlowSelectionComponentBackground = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #e5e5e5;
  background-repeat: no-repeat;
  background-size: cover;
`

export const FlowSelectionComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 5px;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: unset;
  }
`

export const FlowSelectionComponentHeading = styled.h1`
  font-size: 30px;
  color: #000;
  font-weight: 500;
  text-align: center;
  margin-bottom: 30px;
  @media (min-width: 768px) {
    font-size: 40px;
  }
`

export const FlowSelectionItemContainer = styled.button`
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 16px;
  transition: border 0.5s ease 0s;
  width: 100%;
  max-width: 500px;
  @media (min-width: 768px) {
    flex-direction: column;
    align-items: center;
    max-width: 230px;
  }
  &:hover {
    border: 1px solid #434e64;
  }
`

export const FlowSelectionItemImage = styled.img`
  width: 64px;
  height: 64px;
  margin-right: 16px;
  @media (min-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
`

export const FlowSelectionItemInternalContainer = styled.div`
  width: 100%;
  text-align: left;
  @media (min-width: 768px) {
    text-align: center;
  }
`

export const FlowSelectionItemTitle = styled.h6`
  font-size: 18px;
  font-family: Outfit;
  color: rgb(40, 44, 47);
  margin: 0;
  font-weight: 600;
  margin-top: 6px;
  margin-bottom: 6px;
  @media (min-width: 768px) {
    font-size: 20px;
    margin: 6px 0 6px;
  }
`

export const FlowSelectionItemSubtext = styled.p`
  font-family: Outfit;
  font-size: 13px;
  margin: 6px 0;
  line-height: 1.5;
  color: rgb(40, 44, 47);
  @media (min-width: 768px) {
    font-size: 16px;
  }
`
